export const FilterIcon = (props: React.SVGProps<SVGSVGElement>) => (
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 16 13" width="16" height="13" fill="none" {...props}>
        <path
            d="M8.45 9.48C8.22 8.07 6.98 6.98 5.5 6.98C4.02 6.98 2.78 8.07 2.55 9.48H0V10.48H2.55C2.78 11.9 4.02 12.98 5.5 12.98C6.98 12.98 8.22 11.9 8.45 10.48H16V9.48H8.45ZM5.5 11.98C4.4 11.98 3.5 11.08 3.5 9.98C3.5 8.88 4.4 7.98 5.5 7.98C6.6 7.98 7.5 8.88 7.5 9.98C7.5 11.08 6.6 11.98 5.5 11.98Z"
            fill="currentColor"
        />
        <path
            d="M13.45 2.5C13.22 1.08 11.98 0 10.5 0C9.02 0 7.78 1.08 7.55 2.5H0V3.5H7.55C7.78 4.91 9.02 6 10.5 6C11.98 6 13.22 4.91 13.45 3.5H16V2.5H13.45ZM10.5 5C9.4 5 8.5 4.1 8.5 3C8.5 1.9 9.4 1 10.5 1C11.6 1 12.5 1.89 12.5 3C12.5 4.11 11.6 5 10.5 5Z"
            fill="currentColor"
        />
    </svg>
);
